"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var FlagsClient = (function () {
    function FlagsClient(config) {
        this.config = config;
        this.flags = [];
        this.checkValidInstance();
    }
    FlagsClient.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetchFlags()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    FlagsClient.prototype.getFlags = function () {
        return this.flags;
    };
    FlagsClient.prototype.getFlag = function (flagName) {
        return this.flags.filter(function (flag) { return flag.name === flagName; })[0];
    };
    FlagsClient.prototype.fetchFlags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, appName, instanceId, _b, extraHttpHeaders, headers, response, json, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.config, url = _a.url, appName = _a.appName, instanceId = _a.instanceId, _b = _a.extraHttpHeaders, extraHttpHeaders = _b === void 0 ? {} : _b;
                        headers = __assign({ 'Content-Type': 'application/json', 'UNLEASH-APPNAME': appName || '', 'UNLEASH-INSTANCEID': instanceId || '' }, extraHttpHeaders);
                        return [4, fetch(url + "/client/features/", {
                                headers: headers,
                                method: 'GET',
                            })];
                    case 1:
                        response = _d.sent();
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        return [4, response.json()];
                    case 3:
                        json = _d.sent();
                        this.flags = json.features;
                        return [3, 5];
                    case 4:
                        _c = _d.sent();
                        this.flags = [];
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    FlagsClient.prototype.checkValidInstance = function () {
        if (!this.config) {
            throw Error('No config provided!');
        }
        var _a = this.config, url = _a.url, appName = _a.appName, instanceId = _a.instanceId;
        if (!url || !appName || !instanceId) {
            throw Error('Provided config is incomplete!');
        }
    };
    return FlagsClient;
}());
exports.default = FlagsClient;
//# sourceMappingURL=FlagsClient.js.map